import React from 'react';
import { Box } from '@mui/material';
import DataList from '../accordianDataList/dataList';

const AccordianCommonRequests = (props) =>
{
    
    return (
        <Box className={"summaryContentBox"} sx={props.setAutoHeight ? {height: 'auto !important'} : {height: '100%'}}>
            <DataList
                {...props}
                data={props.data}
                // onCheckSelect={onCheckSelect}
                editRow={props.editRow}
                handleClick={props.handleClick}
                onSettingClick={props.onSettingClick}
                title={props.title}
                outfitInfo={props.outfitInfo}
                buttonTitle={props.buttonTitle}
                deleteRows={props.deleteRows}
                showSearch={props.showSearch}
                searchLabel={props.searchLabel}
                showFilter={props.showFilter}
                filters={props.filters}
                multiApprove={props.multiApprove}
                multiReject={props.multiReject}
                hideAdd={props.hideAdd == true ? true : false}
                showSearchRec={props.showSearchRec}
                setShowSearchRec={props.setShowSearchRec}
                onSwitchToggle={props.onSwitchToggle}
                onActionClick={props.onActionClick}
                showSync={props.showSync}
                showExport={props.showExport}
                showSettings={props.showSettings}
                callExport={props.callExport}
                getResults={props.getResults}
                pagingInfo={props.pagingInfo}
                handlePageChange={props.handlePageChange}
                onPendingAction={props.onPendingAction}
                moduleToShow={props.moduleToShow}
                modPermission={props.modPermission}
                filterListData={props.filterListData}
                disableAdd={props.disableAdd}
                hideSelectAll={props.hideSelectAll}
                hideReject={props.hideReject}
                hideApprove={props.hideApprove}
                customExportTitle={props.customExportTitle}
            />
        </Box>
    );
};

export default AccordianCommonRequests;
